import * as Sentry from "@sentry/tanstackstart-react";
import { resolveSentryEnvironment, scrubSentryEvent } from "./lib/sentryShared";

const dsn = import.meta.env.VITE_SENTRY_DSN;

Sentry.init({
  dsn: dsn || undefined,
  enabled: Boolean(dsn),
  environment: resolveSentryEnvironment(),
  sendDefaultPii: false,
  // Error monitoring only for launch — no Session Replay (PII surface).
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 0,
  beforeSend(event) {
    return scrubSentryEvent(event as unknown as Record<string, unknown>) as typeof event | null;
  },
});
